import React from 'react';
import { classes } from './Divider.st.css.js';
class Divider extends React.PureComponent {
    render() {
        return React.createElement("div", { className: classes.root });
    }
}
Divider.displayName = 'Divider';
export default Divider;
//# sourceMappingURL=Divider.js.map